<template>
  <div id="newsPost">
    <div class="scroll">
      <div class="holder" :class="{pinned: $store.state.isDesktop}">
        <div class="top">
          <div class="content" v-if="post">
            <div class="head">
              <Slider ref="slider" class="slider" v-if="image">
                <div class="slide" :style="{'background-image': 'url(' + image + ')'}"></div>
              </Slider>
              <div class="dots" v-if="$refs.slider && $refs.slider.getPageCount() > 1">
                <div class="dot" v-for="(n, index) in $refs.slider.getPageCount()" :key="index" :class="{active: $refs.slider.getPage == index}"></div>
              </div>
              <div class="right grow">
                <div class="title">{{ $to(post.title) }}</div>
                <div class="hr grow"></div>
                <div class="subtitle">{{ $to(post.subTitle) }}</div>
                <div class="date">{{ formatDate(post.createdAt) }}</div>
              </div>
            </div>
            <div class="description">{{ $to(post.body) }}</div>
          </div>
        </div>
        <div class="hr" v-if="post && post.documents.length > 0"></div>
        <div class="bottom documents" v-if="post && post.documents.length > 0">
          <div class="document" v-for="(document, documentIndex) of post.documents" :key="'document-' + documentIndex">
            <div class="icon">
              <svgicon src="svg/paperclip.svg" :height="20" :width="20"></svgicon>
            </div>
            <div class="name">{{document.name}}</div>
            <ExternalLink class="btn btn-neutral" :url="(CONFIG.urlFiles + document.url)" :target="target">
              <svgicon src="svg/download.svg" :height="16" :width="16" ></svgicon>
            </ExternalLink>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons">
      <div class="btn btn-secondary" :class="{'button-desktop': $store.state.isDesktop}" @click="back">{{ $t("news.back") }}</div>
    </div>
  </div>
</template>

<script>

  import Slider from "../components/Slider.vue";
  import News from "../../core/News";
  import ExternalLink from "../components/ExternalLink";

  export default {

    name: "newsPost",

    components: {ExternalLink, Slider },

    data() {
      return {
        News,
        CONFIG
      };
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "page.news",
        headerIcon: "/svg/news.svg"
      });
      setTimeout(()=>this.$forceUpdate(),0);
    },

    computed: {
      post() {
        return this.News.get(this.$route.params.id);
      },
      image() {
        if (this.post && this.post.image != null) {
          return CONFIG.urlFiles + this.post.image;
        }
      },
      target() {
        if (typeof cordova != "undefined" && typeof device != "undefined"  && device.platform == "Android") {
          return "_system";
        } else {
          return "_blank";
        }
      }
    },

    methods: {
      back() {
        this.$router.push("/news");
      },
      formatDate(date) {
        if (this.$ts.state.locale == "en") {
          return date.format("MMMM DD, YYYY | HH:mm");
        }
        return date.format("DD MMMM YYYY | HH:mm");
      }
    }

  }

</script>

<style lang="scss" scoped>

  #newsPost {
    background-color: #f2f3f4;
    display: flex;
    flex-direction: column;
  }

  .slider {
    background-color: white;
    padding-right: 40px;
    padding-bottom: 10px;
    .slide {
      background-size: cover;
      background-position: center;
      border-radius: 3px;
    }
  }

  .holder .head {
    display: flex;
    align-items: flex-end;
    margin-bottom: 20px;

    .right.grow {
      flex-grow: 1;
    }

    .hr {
      margin: 10px 0;
    }
  }

  .holder {
    display: flex;
    flex-direction: column;

    .hr {
      margin: 0 20px;
      &.grow {
        flex-grow: 1;
      }
      width: auto;
    }
  }

  .documents {
    display: flex;
    flex-wrap: wrap;
    margin: 30px 10px 10px 10px;

    .document {
      width: calc(50% - 20px);
      margin: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f2f2f2;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      border-radius: 3px;

      .name {
        padding: 15px;
        font-size: 14px;
        flex-grow: 1;
        font-weight: bold;
      }

      .icon {
        min-height: 55px;
        height: 100%;
        width: 60px;
        flex-shrink: 0;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        background-color: #001722;
        fill: white;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn {
        margin-right: 10px;
        height: calc(100% - 20px);
      }

    }
  }

  .content {
    padding: 20px;
  }

  .title {
    font-size: 24px;
  }

  .subtitle {
    font-size: 22px;
    color: #666666;
  }

  .date {
    color: #808b91;
    font-size: 14px;
    margin-top: 6px;
    margin-bottom: 20px;
  }

  .description {
    margin-bottom: 40px;
    white-space: pre-wrap;
  }

  .buttons {
    display: flex;
    .btn {
      flex-grow: 1;
      flex-basis: 0;
      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }

  .dots {
    position: absolute;
    top: 170px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: white;
      border: 2px solid white;
      &.active {
        background-color: black;
      }
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }

  /* MOBILE ONLY RULES */
  @media screen and (max-width: 600px) {

    .btn {
      flex-grow:1;
    }

    .documents {
      flex-direction: column;
      flex-wrap: nowrap;

      .document {
        width: 100%;
        margin: 0 0 20px 0;
        background-color: white;
      }
      .btn {
        flex-grow: initial;
      }
    }

    .buttons {
      padding: 20px;
    }

    .scroll {
      flex-grow:1;
    }
  }

  @media screen and (max-width: 1200px) {
    #newsPost .holder .head {
      flex-direction: column;
      align-items: center;

      .slider {
        padding-right: 0;
        padding-bottom: 20px;
        max-width: 100% !important;
      }

      .right {
        width: 100%;
      }
    }
  }

  /* DESKTOP ONLY RULES */
  @media screen and (min-width: 601px) {
    #newsPost {
      background-color: #f2f3f4;
      padding:30px 60px 30px 60px ;

      .scroll {
        flex-grow:1;
      }

      .pinned {
        background-color: white;
        margin-bottom: 20px;
        border-radius: 3px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        padding:30px;
      }

      .pinned .top {
        flex-direction: row;
        display: flex;

        .slider {
          flex-shrink:0;
          height: 260px;
          width: 100%;
          max-width: 450px;
          background-color: white;
          .slide {
            background-size: cover;
            background-position: center;
          }
        }
        .content {
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          .title {
            font-size:28px;
            font-weight: 500;
          }
          .description {
            font-size:18px;
            flex-grow: 1;
          }
        }
      }
    }

    .buttons {
      padding:20px 0 0 0;
      justify-content: flex-start;
      //flex-grow:1;
      .btn.button-desktop {
        min-width:160px;
        flex-grow:0;
        display: flex;
        justify-content: center;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .slider {
      height: 280px;
      background-color: #f2f3f4;
    }
  }

</style>
